"use client";

import { useQuery } from "@tanstack/react-query";
import { fetchOfficeJobs } from "~www/actions/fetch-office-jobs";

type OfficeJobsParams = {
  enabled?: boolean;
  officeNumber: number;
};

const useOfficeJobs = (params: OfficeJobsParams) => {
  const enabled = params.enabled ?? params.officeNumber > 0;

  return useQuery({
    enabled,
    queryFn: () => fetchOfficeJobs(params.officeNumber),
    queryKey: ["officeJobs", params.officeNumber],
  });
};

export type { OfficeJobsParams };

export { useOfficeJobs };
